import type React from 'react';

import { Link, Separator, Text } from '@change/ds-core-ui';

import { Translate, TranslateHtml, useI18n } from '@change-corgi/core-react/i18n';

import { LoginEmailForm } from './components/LoginEmailForm';
import { LoginSocialButtons } from './components/LoginSocialButtons';
import { useEmailStep } from './hooks/useEmailStep';

export const EmailStep: React.FC = () => {
	return (
		<div>
			<EmailStepInner />
			<Text className="mt-4" as="div" size="small" data-testid="disclaimer-text">
				<TranslateHtml
					value="corgi.login_or_signup.email.disclaimer_v3"
					replacements={{
						termsOfServiceLink: (
							<Link
								href="https://www.change.org/policies/terms-of-service"
								target="_blank"
								data-qa="terms-of-service-link"
								size="small"
							>
								<Translate value="corgi.login_or_signup.email.terms_of_service" />
							</Link>
						),
						privacyPolicyLink: (
							<Link
								href="https://www.change.org/policies/privacy"
								target="_blank"
								data-qa="privacy-policy-link"
								size="small"
							>
								<Translate value="corgi.login_or_signup.email.privacy_policy" />
							</Link>
						),
					}}
				/>
			</Text>
		</div>
	);
};

const EmailStepInner: React.FC = () => {
	const {
		data: { showSocialButtons },
	} = useEmailStep();
	const { translate } = useI18n();

	if (!showSocialButtons) return <LoginEmailForm />;

	return (
		<>
			<LoginEmailForm />
			<Separator className="mt-8 mb-7" label={translate('corgi.login_or_signup.email.or')} />
			<LoginSocialButtons data-qa="login-social-buttons" />
		</>
	);
};
